'use client'
import { useChangeQuery } from '@/hooks/use-create-query'
import { Box, Chip, FormControl, MenuItem, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import { usePathname, useSearchParams } from 'next/navigation'
import React, { useEffect, useRef, useState } from 'react'
import { StyledSelect } from './styled-components'
type Props = {
  defaultValue?: string
}

const ignoreFilter = ['Sort Name (no accent)']

export const ProductSort: React.FC<Props> = ({ defaultValue }) => {
  const t = useTranslations('')

  const searchParams = useSearchParams()
  const pathname = usePathname()
  const hasInitialized = useRef(false)
  const [selectedValue, setSelectedValue] = useState<string>(searchParams.get('sort') || '')
  const { createQueryString } = useChangeQuery()

  const sortValue = searchParams.get('sort')
  const sortByValue = searchParams.get('sortBy')

  const handleSort = (value: string) => {
    const sortArrs = value.split(',')
    window.history.pushState(
      null,
      '',
      `${pathname}?${createQueryString(['sort', 'sortBy', 'page'], [sortArrs[0], sortArrs[1], '1'])}`
    )
    setSelectedValue(value)
  }
  //set default value cho select

  useEffect(() => {
    if (!hasInitialized.current && (defaultValue || sortValue)) {
      setSelectedValue((sortValue + ',' + sortByValue) as string)
      hasInitialized.current = true
    }
  }, [defaultValue, sortByValue, sortValue])
  // tạo 1 mảng mới sử dụng các field của listProduct.sort_fields, tạo ra các lựa chọn tăng dần và giảm dần
  const listSortOptions = [
    // { label: 'Tên từ A đến Z', value: 'name,ASC' },
    // { label: 'Tên từ Z đến A', value: 'name,DESC' },
    { label: 'Giá thấp -> cao', value: 'price,ASC' },
    { label: 'Giá cao -> thấp', value: 'price,DESC' },
  ]

  return (
    <FormControl>
      {/* <StyledSelect
        labelId="sort-select-label"
        name="sort-product"
        onChange={(e) => handleSort(e.target.value as string)}
        value={selectedValue || ''}
        displayEmpty
        variant="standard"
        MenuProps={{
          disableScrollLock: true,
        }}
        sx={{
          boxShadow: 'none',
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '&:before': {
            border: 'none',
          },
          '&:after': {
            border: 'none',
          },
        }}
      >
        <MenuItem value="" disabled>
          {t('Mặc định')}
        </MenuItem>
        {listSortOptions?.map((el, index) => (
          <MenuItem key={index} value={el?.value}>
            {el?.label}
          </MenuItem>
        ))}
      </StyledSelect> */}
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'center' }}>
        <Typography variant="body2">{t('Sắp xếp theo:')}</Typography>

        {listSortOptions?.map((el, index) => {
          const isSelected = selectedValue === el?.value
          return (
            <Chip
              key={index}
              label={el?.label}
              onClick={() => handleSort(el?.value)}
              variant={isSelected ? 'filled' : 'outlined'}
              color={isSelected ? 'primary' : 'default'}
              sx={{
                borderRadius: '8px',
                fontWeight: isSelected ? 'bold' : 'normal',
                '&:hover': {
                  backgroundColor: isSelected ? 'primary.main' : 'rgba(0, 0, 0, 0.04)',
                },
              }}
            />
          )
        })}
      </Box>
    </FormControl>
  )
}
